
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/apartment-clean",
      function () {
        return require("private-next-pages/services/apartment-clean.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/apartment-clean"])
      });
    }
  